import { render, staticRenderFns } from "./RPageNotFound.vue?vue&type=template&id=a7dc88f8&scoped=true"
import script from "./RPageNotFound.vue?vue&type=script&lang=js"
export * from "./RPageNotFound.vue?vue&type=script&lang=js"
import style0 from "./RPageNotFound.vue?vue&type=style&index=0&id=a7dc88f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dc88f8",
  null
  
)

export default component.exports